import TabbedSubmenu from '../../core/TabbedSubmenu';
import { Typography } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import PublishIcon from '@material-ui/icons/Publish';
import CategoryIcon from '@material-ui/icons/Category';
import SyncProblemIcon from '@material-ui/icons/SyncProblem';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { APPLICATION_PATHS } from '../../application-core/constants';
import AreYouSure from '../../core/AreYouSure';
import ProjectImportContainer from '../../core/project/ProjectImportContainer';
import { UserConsumer } from '../../core/providers/UserProvider';
import { ProjectConsumer } from '../../core/providers/ProjectProvider';
import SecondaryButton from '../../core/SecondaryButton';
import { globalStyles as styles } from '../../core/style/gstheme';
import { ENTITLEMENTS as APPENTITLEMENTS } from '../../core/utils/constants';
import GS from '../../grafsync/grafsync';
import SuggestionsManager from './SuggestionsManager';
import AnnotateCleanupIcon from '../../core/icons/AnnotateCleanUp';
import AccessibleTooltip from '../../core/AccessibleTooltip';

const baseLink = APPLICATION_PATHS.TAXONOMY_MANAGER + '/project/reload';
const ADD_DEFAULT_CLASS = "addClasses";
const ADD_INSCHEME = "addScheme";
const MATERIALISE = "materialise";
const ANNOTATE_CLEANUP = "schemeAnnotationCleanup";

class SchemeData extends Component {

  constructor(props) {
    super(props);
    this.state = {
      action: "",
      areYouSure: false,
      operation: "",
      sureMessage: []
    };
  }

  checkIfSure = (operation, sureMessage) => this.setState({ areYouSure: true, sureMessage, operation });

  onNotSure = () => this.setState({ areYouSure: false, sureMessage: [], operation: "" });

  onSure = async () => {
    this.setState({ areYouSure: false, sureMessage: [] });
    try {
      // We need to ensure messages are processed or batch lock will cause rejection
      await GS.waitForEditsToClear();
      await GS.operate("batchupdateTaxonomyProject", this.props.graph, {
        action: this.state.operation,
        scheme: this.props.schemeIRI
      });
    }
    catch (e) {
      this.setState({ isErrored: { message: "Cannot perform operation." } });
    }
  };

  setAction = (action) => this.setState({ action });

  cancelAction = () => this.setState({ action: "" });

  render() {

    const { action, areYouSure, sureMessage } = this.state;
    const { graph, schemeIRI, project, useSlashIRI, useUuidIRI, useCounterIRI, iriOptions, taxonomies, collections, useWorkflow,
      useXL, defaultClasses, classes, isReadOnly, annotate, projectUsers, counters } = this.props;

    // Import is a subscription level entitlement so we get subscription level entitlements rather than project level

    return (
      <UserConsumer>
        {({ entitlements }) =>
          <ProjectConsumer>
            {({ defaultLang, skosXL, hasComponent, ontologyProjectAssociation }) => (
              <div style={{ padding: 30 }}>
                {action === "import" ?
                  <div>
                    <div style={{ float: 'right', marginBottom: 20 }}>
                      <SecondaryButton onClick={this.cancelAction}>Cancel Merge</SecondaryButton>
                    </div>
                    <Typography paragraph className={classes.mainHeading}>Merge Data</Typography>
                    <TabbedSubmenu tabs={["By Label At Taxonomy Level", "By IRI"]}>
                      <div>
                        <Typography paragraph variant="body2">This will merge data onto this taxonomy as top concepts using preferred labels as the basis for hierarchy and references.</Typography>
                        <Typography paragraph variant="body2">We recommend running a quality check after import.</Typography>
                        <ProjectImportContainer
                          baseLink={baseLink}
                          center={true}
                          key="byLabel"
                          spreadsheetOnly={true}
                          disableScreen={true}
                          includeOptions={false}
                          configOptions="taxonomy"
                          existingComponents={[].concat(taxonomies, collections)}
                          xrefComponents={taxonomies}
                          useSlashIRI={useSlashIRI}
                          byIRI={false}
                          useUuidIRI={useUuidIRI}
                          useOptions={{
                            baseIRI: schemeIRI,
                            lang: defaultLang,
                            useXL: useXL,
                            removeSpaces: iriOptions.removeSpaces,
                            replaceSpaces: iriOptions.replaceSpaces,
                            removeSpecialCharacters: iriOptions.removeSpecialCharacters,
                            replaceSpecialCharacters: iriOptions.replaceSpecialCharacters,
                            minimiseEncoding: iriOptions.minimiseEncoding,
                            prependText: iriOptions.xlOptions.prependText,
                            appendText: iriOptions.xlOptions.shouldAppendText ? defaultLang : ""
                          }}
                          subLink={"taxonomy=" + schemeIRI}
                          importContext={{
                            situation: "AttachToScheme",
                            resourceIRI: schemeIRI,
                            baseIRI: schemeIRI
                          }}
                          graph={graph}
                          id={project} />
                      </div>
                      <div>
                        <Typography paragraph variant="body2">This will merge data onto existing concepts in this taxonomy using IRIs as the references.</Typography>
                        <Typography paragraph variant="body2">We recommend running a quality check after import.</Typography>
                        <ProjectImportContainer
                          baseLink={baseLink}
                          center={true}
                          key="byIRI"
                          spreadsheetOnly={true}
                          disableScreen={true}
                          includeOptions={false}
                          configOptions="taxonomy"
                          existingComponents={[].concat(taxonomies, collections)}
                          xrefComponents={taxonomies}
                          useSlashIRI={useSlashIRI}
                          useUuidIRI={useUuidIRI}
                          useOptions={{
                            baseIRI: schemeIRI,
                            lang: defaultLang,
                            useXL: useXL,
                            removeSpaces: iriOptions.removeSpaces,
                            replaceSpaces: iriOptions.replaceSpaces,
                            removeSpecialCharacters: iriOptions.removeSpecialCharacters,
                            replaceSpecialCharacters: iriOptions.replaceSpecialCharacters,
                            minimiseEncoding: iriOptions.minimiseEncoding,
                            prependText: iriOptions.xlOptions.prependText,
                            appendText: iriOptions.xlOptions.shouldAppendText ? defaultLang : ""
                          }}
                          subLink={"taxonomy=" + schemeIRI}
                          byIRI={true}
                          importContext={{
                            situation: "FullMergeBySpreadsheet",
                            resourceIRI: schemeIRI,
                            baseIRI: schemeIRI
                          }}
                          graph={graph}
                          id={project} />
                      </div>
                    </TabbedSubmenu>
                  </div>
                  :
                  <div>
                    <div style={{ textAlign: 'right', marginBottom: 36 }}>
                      {!isReadOnly && defaultClasses && defaultClasses.length > 0 &&
                        <span style={{ marginRight: 12 }}>
                          <AccessibleTooltip title="Add default classes to all concepts that are in the scheme">
                            <IconButton aria-label="Add default classes to all concepts that are in the scheme" data-test="add-default-class" size="small" onClick={() => this.checkIfSure(ADD_DEFAULT_CLASS,
                              [
                                "This operation will add any default classes defined for the taxonomy to all concepts that have an 'In Scheme' value that is this taxonomy.",
                                "This is a batch operation and will lock the project."
                              ])}>
                              <CategoryIcon />
                            </IconButton>
                          </AccessibleTooltip>
                        </span>
                      }
                      {!isReadOnly && ontologyProjectAssociation && ontologyProjectAssociation.length > 0 &&
                        <span style={{ marginRight: 12 }}>
                          <AccessibleTooltip title="Synchronise all inverse and symmetric relationships">
                            <IconButton aria-label="Synchronise all inverse and symmetric relationships" data-test="materialise" size="small" onClick={() => this.checkIfSure(MATERIALISE,
                              [
                                "This operation will add any missing inverse and symmetric relationships on concepts and SKOS-XL labels that are in the scheme.",
                                "Note that this will only apply to relationships that are wholly within the scheme or outbound from the concepts or labels in this scheme.",
                                "If there are other taxonomies with outbound symmetric or inverse relationships that target concepts or labels in this scheme, you will need to process them separately.",
                                "This is a batch operation and will lock the project."
                              ])}>
                              <SyncProblemIcon />
                            </IconButton>
                          </AccessibleTooltip>
                        </span>
                      }
                      {!isReadOnly &&
                        <span style={{ marginRight: 12 }}>
                          <AccessibleTooltip title="Make all concepts in the hierarchy belong to this scheme">
                            <IconButton aria-label="Make all concepts in the hierarchy belong to this scheme" data-test="add-inscheme" size="small" onClick={() => this.checkIfSure(ADD_INSCHEME,
                              [
                                "This operation will add all concepts that are in the hierarchy to the scheme (add 'In Scheme' for this taxonomy).",
                                "This is a batch operation and will lock the project."
                              ])}>
                              <PlaylistAddIcon />
                            </IconButton>
                          </AccessibleTooltip>
                        </span>
                      }
                      {!isReadOnly && annotate &&
                        <span style={{ marginRight: 12 }}>
                          <AccessibleTooltip title="Remove all unconnected annotations">
                            <IconButton aria-label="Remove all unconnected annotations" data-test="annotate-cleanup" size="small" onClick={() => this.checkIfSure(ANNOTATE_CLEANUP,
                              [
                                "This operation will remove any annotations that are no longer connected for this taxonomy.",
                                "This is a batch operation and will lock the project."
                              ])}>
                              <AnnotateCleanupIcon />
                            </IconButton>
                          </AccessibleTooltip>
                        </span>
                      }
                      {entitlements.includes(APPENTITLEMENTS.CAN_IMPORT) && !useCounterIRI &&
                        <AccessibleTooltip title="Merge a TSV, CSV or spreadsheet file onto this taxonomy">
                          <IconButton aria-label="Merge a TSV, CSV or spreadsheet file onto this taxonomy" data-test="import-spreadsheet" size="small" onClick={() => this.setAction("import")}>
                            <PublishIcon />
                          </IconButton>
                        </AccessibleTooltip>
                      }
                    </div>
                    <SuggestionsManager
                      defaultType="NewConceptSuggestion"
                      schemeIRI={schemeIRI}
                      projectIRI={project}
                      componentLevel={true}
                      projectUsers={projectUsers}
                      components={hasComponent}
                      optionForXL={skosXL}
                      useWorkflow={useWorkflow}
                      useXL={useXL}
                      useCounterIRI={useCounterIRI}
                      counters={counters}
                      iriOptions={iriOptions}
                      defaultClasses={defaultClasses}
                      isVisible={true}
                      useSlashIRI={useSlashIRI}
                      useUuidIRI={useUuidIRI}
                      entitlements={entitlements}
                      defaultLang={defaultLang}
                      handleNotAvailable={true}
                      id={schemeIRI}
                      graph={graph} />
                  </div>
                }
                {areYouSure && <AreYouSure onSure={this.onSure} onNotSure={this.onNotSure} message={sureMessage} />}
              </div>
            )}
          </ProjectConsumer>
        }
      </UserConsumer>
    );
  }
}

SchemeData.propTypes = {
  classes: PropTypes.object,
  entitlements: PropTypes.array.isRequired,
  project: PropTypes.string.isRequired,
  defaultClasses: PropTypes.array,
  graph: PropTypes.string.isRequired,
  viewLang: PropTypes.string,
  collections: PropTypes.array,
  taxonomies: PropTypes.array,
  schemeIRI: PropTypes.string,
  annotate: PropTypes.bool,
  useWorkflow: PropTypes.bool,
  useSlashIRI: PropTypes.bool,
  useCounterIRI: PropTypes.bool,
  counters: PropTypes.object,
  projectUsers: PropTypes.array,
  useUuidIRI: PropTypes.bool,
  useXL: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  iriOptions: PropTypes.object
};

export default withStyles(styles)(SchemeData);